<div style="width:100%; height:600px;">
    <H3 *ngIf="supplier">{{supplier.SupplierName}}</H3>
    <nav class="nav nav-tabs">
        <a class="nav-item nav-link active" href="#panelWorkflow" data-bs-toggle="tab"><i class="fas fa-clipboard-list mr-3"></i>Historique du workflow</a>
        <a class="nav-item nav-link " href="#panelModifs" data-bs-toggle="tab"><i class="fas fa-edit mr-3"></i>Historique des modifications</a>
    </nav>

    <div class="tab-content">
        <div class="tab-pane active" id="panelWorkflow">
           
                <div class="d-flex flex-column align-items-center" style="height:100%;width:100%;">

                    <table class="table table-sm table-striped table-condensed table-responsive small flex-1"
                        style="width:100%;max-height:600px;">
                        <thead>
                            <tr>
                                <th style="min-width:130px;" paflabel="Date_heure"></th>
                                <th>Mouvement</th>
                                <th style="min-width:200px;" paflabel="Valideur"></th>
                                <th style="min-width:200px;" paflabel="Motif"></th>
                                <th paflabel="Observations" class="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let line of historyLines">
                                <td>{{line.Date | date:'short'}}</td>
                                <td>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <supplier-statut-badge *ngIf="line.forward==true" [ngStyle]="{'padding-left.px':line.PaddingLeft}" [supplierStatutId]="line.StatutIdPrec"></supplier-statut-badge>
                                        <supplier-statut-badge *ngIf="line.forward==false" [ngStyle]="{'padding-left.px':line.PaddingLeft}" [supplierStatutId]="line.StatutId"></supplier-statut-badge>
                                        <i *ngIf="line.forward==false" class="mx-2 fas fa-long-arrow-alt-left"></i>
                                        <i *ngIf="line.forward==true" class="mx-2 fas fa-long-arrow-alt-right"></i>
                                        <supplier-statut-badge *ngIf="line.forward==null ||line.forward==true" [supplierStatutId]="line.StatutId"></supplier-statut-badge>
                                        <supplier-statut-badge *ngIf="line.forward==false" [supplierStatutId]="line.StatutIdPrec"></supplier-statut-badge>
                                    </div>
                                </td>
                                <td>{{line.Valideur}}</td>
                                <td *ngIf="line.WfMotif"  [paflabel]="line.WfMotif.LblCod"></td>
                                <td *ngIf="line.WfMotifLibre">{{line.WfMotifLibre}}</td>
                                <td *ngIf="!line.WfMotif && !line.WfMotifLibre"></td>
                                <td>
                                    <div class="full-width d-flex flex-column align-items-start justify-content-center"  style="white-space:pre-wrap;">
                                        <div *ngIf="line.WfMotif?.Impact" class="d-flex text-warning align-items-center justify-content-start">
                                            <i class="fas fa-exclamation-triangle mr-1"></i>{{line.WfMotif.Impact}}
                                        </div>
                                        <div>{{line.Observations}}</div>
                                    </div>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            <pre *ngIf="sharedDataSvc.debug">{{historyLines | json}}</pre>
        </div>

        <div class="tab-pane" id="panelModifs">
            <table class="table table-sm table-striped table-condensed table-responsive small" style="width:100%;max-height:600px;">
                <thead>
                    <th style="min-width:130px;"><label class="control-label">Date/heure</label></th>
                    <th style="min-width:200px;"><label class="control-label">Auteur</label></th>
                    <th class="col"><label class="control-label">Commentaire</label></th>
                    
                </thead>
                <tbody *ngIf="supplier && supplier.SupplierUpdateComments">
                    <tr *ngFor="let line of supplier.SupplierUpdateComments">
                        <td>{{line.UpdateDate |date: 'dd/MM/yyyy hh:mm'}}</td>
                        <td>{{auteurCommentaire(line)}}</td>
                        <td>{{line.Comment}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="width:100%;" class="text-center">
        <button type="button" class="btn btn-primary" (click)="closeWindow()"
            paflabel="Fermer"></button>
    </div>
</div>